import React from 'react';
import moment from 'moment/min/moment-with-locales';
import { colors } from "../components/Theme/WebTheme";
import {
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Grid,
} from '@mui/material';
import { useTranslation } from "react-i18next";
export const calcEst = false;
export const showEst = true;
export const optionsRequired = false;


export const MAIN_COLOR = "#0811ae";
export const SECONDORY_COLOR = colors.TAXISECONDORY;

// Helper function to get currency symbol based on country
export const getCurrencySymbol = (country, settings) => {
  console.log('🔍 getCurrencySymbol called with:', { 
    country, 
    countryType: typeof country,
    hasSettings: !!settings,
    settingsKeys: settings ? Object.keys(settings).filter(k => k.includes('symbol')).slice(0, 5) : []
  });
  
  if (!country || !settings) {
    console.log('❌ Missing country or settings, returning default:', settings?.symbol || '$');
    return settings?.symbol || '$';
  }

  const countryLower = country.toLowerCase().trim();
  console.log('✅ Country (lowercase, trimmed):', `"${countryLower}"`);
  
  // Fallback symbols if settings don't have country-specific ones
  const defaultSymbols = {
    burundi: "FBu",
    canada: "CAD",
    "democratic republic of the congo": "FC",
    kenya: "KSh",
    "south africa": "R",
    rwanda: "RWF",
    uganda: "UGX",
    nigeria: "₦",
    zambia: "ZMW",
    tanzania: "TSh",
    "united republic of tanzania": "TSh",
    benin: "CFA",
    "burkina faso": "CFA",
    burkina_faso: "CFA",
    cameroon: "CFA",
    gabon: "CFA",
    ghana: "GH₵",
    lesotho: "L",
    malawi: "MK",
    mozambique: "MT",
    senegal: "CFA",
    "sierra leone": "Le",
    sierra_leone: "Le",
  };
  
  const symbolMapping = {
    burundi: settings.symbol_burundi || defaultSymbols.burundi,
    canada: settings.symbol_canada || defaultSymbols.canada,
    "democratic republic of the congo": settings.symbol_drc || defaultSymbols["democratic republic of the congo"],
    kenya: settings.symbol_kenya || defaultSymbols.kenya,
    "south africa": settings.symbol_rsa || defaultSymbols["south africa"],
    rwanda: settings.symbol_rwanda || defaultSymbols.rwanda,
    uganda: settings.symbol_uganda || defaultSymbols.uganda,
    nigeria: settings.symbol_nigeria || defaultSymbols.nigeria,
    zambia: settings.symbol_zambia || defaultSymbols.zambia,
    tanzania: settings.symbol_tanzania || defaultSymbols.tanzania,
    "united republic of tanzania": settings.symbol_tanzania || defaultSymbols.tanzania,
    benin: settings.symbol_benin || defaultSymbols.benin,
    "burkina faso": settings.symbol_burkina_faso || defaultSymbols["burkina faso"],
    burkina_faso: settings.symbol_burkina_faso || defaultSymbols.burkina_faso,
    cameroon: settings.symbol_cameroon || defaultSymbols.cameroon,
    gabon: settings.symbol_gabon || defaultSymbols.gabon,
    ghana: settings.symbol_ghana || defaultSymbols.ghana,
    lesotho: settings.symbol_lesotho || defaultSymbols.lesotho,
    malawi: settings.symbol_malawi || defaultSymbols.malawi,
    mozambique: settings.symbol_mozambique || defaultSymbols.mozambique,
    senegal: settings.symbol_senegal || defaultSymbols.senegal,
    "sierra leone": settings.symbol_sierra_leone || defaultSymbols["sierra leone"],
    sierra_leone: settings.symbol_sierra_leone || defaultSymbols.sierra_leone,
  };

  const resolvedSymbol = symbolMapping[countryLower] || settings.symbol || '$';
  
  console.log('💰 Symbol resolution:', {
    country: countryLower,
    fromSettings: settings[`symbol_${countryLower.replace(/ /g, '_')}`] || settings.symbol_rsa,
    fallback: defaultSymbols[countryLower],
    finalSymbol: resolvedSymbol,
    usingFallback: !settings[`symbol_${countryLower.replace(/ /g, '_')}`]
  });
  
  return resolvedSymbol;
};

export const bookingHistoryColumns = (role, settings, t, isRTL, defaultCurrencySymbol) => [
  { title: t('booking_ref'), field: 'reference'},
  { title: t('booking_date'), field: 'bookingDate', render: rowData => rowData.bookingDate?moment(rowData.bookingDate).format('lll'):null},
  { title: t('car_type'), field: 'carType'},
  { title: t('assign_driver'), field: 'driver_name'},
  { title: t('booking_status_web'), field: 'status',
   render: rowData => 
  <div
  style={{backgroundColor:rowData.status === "CANCELLED"?colors.RED :rowData.status=== "COMPLETE"?colors.GREEN : colors.YELLOW, color:"white", padding:7, borderRadius:"15px", fontWeight:"bold", width:"150px", margin: 'auto' }}
  >{t(rowData.status)}</div>,  },
    { title: t('otp'), field: 'otp',
  },
  { title: t('trip_cost'), field: 'trip_cost',
  render: (rowData) => {
    // Try to get customer's country from booking data
    // bookingData.country is set when booking is created (see common/src/other/sharedFunctions.js)
    const customerCountry = rowData.country;
    const symbol = customerCountry 
      ? getCurrencySymbol(customerCountry, settings)
      : (defaultCurrencySymbol || settings.symbol || '$');
    
    console.log('💸 Trip cost render:', { 
      bookingRef: rowData.reference,
      customerCountry, 
      symbol,
      usingDefault: !customerCountry
    });
    
    return rowData.trip_cost
      ? settings.swipe_symbol
        ? rowData.trip_cost + " " + symbol
        : symbol + " " + rowData.trip_cost
      : settings.swipe_symbol
        ? "0 " + symbol
        : symbol + " 0";
  }
 },
];

export const BookingModalBody = (props) => {
    const { t, i18n  } = useTranslation();
    const isRTL = i18n.dir();
    const { classes, handleChange, auth, profileData } = props;
    return (
        <span>
            {auth.profile.usertype === 'customer' && !auth.profile.firstName ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required = {auth.profile.firstName ? false : true }
                fullWidth
                id="firstName"
                label={t('firstname')}
                name="firstName"
                autoComplete="firstName"
                onChange={handleChange}
                value={profileData.firstName}
                autoFocus
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }
            {auth.profile.usertype === 'customer' && !auth.profile.lastName ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required = {auth.profile.lastName ? false : true }
                fullWidth
                id="lastName"
                label={t('lastname')}
                name="lastName"
                autoComplete="lastName"
                onChange={handleChange}
                value={profileData.lastName}
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }
            {auth.profile.usertype === 'customer' && !auth.profile.email ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required = {auth.profile.email ? false : true }
                fullWidth
                id="email"
                label={t('email')}
                name="email"
                autoComplete="email"
                onChange={handleChange}
                value={profileData.email}
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }
            <Typography component="h2" variant="h5" style={{marginTop:15, color:'#000'}}>
                { t('estimate_fare_text')}
            </Typography>
        </span>
    )
}

export const validateBookingObj = (t, bookingObject, instructionData) => {
    delete bookingObject.driverEstimates;
    return { bookingObject };
}

export const PanicSettings = (props) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const { classes, data, handleTextChange } = props;
    return (
        <span>
            <Typography component="h1" variant="h5" style={{ marginTop: '15px', textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
                {t('panic_num')}
            </Typography>
            <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="panic"
                label={t('panic_num')}
                className={isRTL === "rtl" ? [classes.rootRtl_1, classes.right] : classes.textField}
                name="panic"
                autoComplete="panic"
                onChange={handleTextChange}
                value={data.panic}
            />
        </span>
    )
}

export const DispatchSettings = (props) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const { autoDispatch, onChange } = props;
    return (
        <FormControlLabel
            style={{ flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
            control={
                <Switch
                    checked={autoDispatch}
                    onChange={onChange}
                    name="autoDispatch"
                    color="primary"
                />
            }
        label={t('auto_dispatch')}
      />
    )
}

export const BookingImageSettings = (props) => {
    return null;
}

export const carTypeColumns = (t, isRTL, onClick) =>  [
    { title: t('name'), field: 'name', },
    { title: t('image'),  field: 'image',
      initialEditValue: 'https://cdn.pixabay.com/photo/2012/04/15/22/09/car-35502__480.png',
      render: rowData => rowData.image? <button onClick={()=>{onClick(rowData)}}><img alt='CarImage' src={rowData.image} style={{width: 50}}/></button>:null
    },
    { title: t('base_fare'), field: 'base_fare', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_burundi'), field: 'base_fare_burundi', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_canada'), field: 'base_fare_canada', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_drc'), field: 'base_fare_drc', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_kenya'), field: 'base_fare_kenya', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_nigeria'), field: 'base_fare_nigeria', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_rsa'), field: 'base_fare_rsa', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_rwanda'), field: 'base_fare_rwanda', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_uganda'), field: 'base_fare_uganda', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_tanzania'), field: 'base_fare_tanzania', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_benin'), field: 'base_fare_benin', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_burkina_faso'), field: 'base_fare_burkina_faso', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_cameroon'), field: 'base_fare_cameroon', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_gabon'), field: 'base_fare_gabon', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_ghana'), field: 'base_fare_ghana', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_lesotho'), field: 'base_fare_lesotho', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_malawi'), field: 'base_fare_malawi', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_mozambique'), field: 'base_fare_mozambique', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_senegal'), field: 'base_fare_senegal', type: 'numeric',  initialEditValue: 0 },
    { title: t('base_fare_sierra_leone'), field: 'base_fare_sierra_leone', type: 'numeric',  initialEditValue: 0 },

    { title: t('rate_per_unit_distance'), field: 'rate_per_unit_distance', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_burundi'), field: 'rate_per_unit_distance_burundi', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_canada'), field: 'rate_per_unit_distance_canada', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_drc'), field: 'rate_per_unit_distance_drc', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_kenya'), field: 'rate_per_unit_distance_kenya', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_nigeria'), field: 'rate_per_unit_distance_nigeria', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_rsa'), field: 'rate_per_unit_distance_rsa', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_rwanda'), field: 'rate_per_unit_distance_rwanda', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_uganda'), field: 'rate_per_unit_distance_uganda', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_tanzania'), field: 'rate_per_unit_distance_tanzania', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_benin'), field: 'rate_per_unit_distance_benin', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_burkina_faso'), field: 'rate_per_unit_distance_burkina_faso', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_cameroon'), field: 'rate_per_unit_distance_cameroon', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_gabon'), field: 'rate_per_unit_distance_gabon', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_ghana'), field: 'rate_per_unit_distance_ghana', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_lesotho'), field: 'rate_per_unit_distance_lesotho', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_malawi'), field: 'rate_per_unit_distance_malawi', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_mozambique'), field: 'rate_per_unit_distance_mozambique', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_senegal'), field: 'rate_per_unit_distance_senegal', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_unit_distance_sierra_leone'), field: 'rate_per_unit_distance_sierra_leone', type: 'numeric',  initialEditValue: 0},

    { title: t('rate_per_hour'), field: 'rate_per_hour', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_burundi'), field: 'rate_per_hour_burundi', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_canada'), field: 'rate_per_hour_canada', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_drc'), field: 'rate_per_hour_drc', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_kenya'), field: 'rate_per_hour_kenya', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_nigeria'), field: 'rate_per_hour_nigeria', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_rsa'), field: 'rate_per_hour_rsa', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_rwanda'), field: 'rate_per_hour_rwanda', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_uganda'), field: 'rate_per_hour_uganda', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_tanzania'), field: 'rate_per_hour_tanzania', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_benin'), field: 'rate_per_hour_benin', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_burkina_faso'), field: 'rate_per_hour_burkina_faso', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_cameroon'), field: 'rate_per_hour_cameroon', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_gabon'), field: 'rate_per_hour_gabon', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_ghana'), field: 'rate_per_hour_ghana', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_lesotho'), field: 'rate_per_hour_lesotho', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_malawi'), field: 'rate_per_hour_malawi', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_mozambique'), field: 'rate_per_hour_mozambique', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_senegal'), field: 'rate_per_hour_senegal', type: 'numeric',  initialEditValue: 0},
    { title: t('rate_per_hour_sierra_leone'), field: 'rate_per_hour_sierra_leone', type: 'numeric',  initialEditValue: 0},

    { title: t('min_fare'), field: 'min_fare', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_burundi'), field: 'min_fare_burundi', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_canada'), field: 'min_fare_canada', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_drc'), field: 'min_fare_drc', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_kenya'), field: 'min_fare_kenya', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_nigeria'), field: 'min_fare_nigeria', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_rsa'), field: 'min_fare_rsa', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_rwanda'), field: 'min_fare_rwanda', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_uganda'), field: 'min_fare_uganda', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_tanzania'), field: 'min_fare_tanzania', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_benin'), field: 'min_fare_benin', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_burkina_faso'), field: 'min_fare_burkina_faso', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_cameroon'), field: 'min_fare_cameroon', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_gabon'), field: 'min_fare_gabon', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_ghana'), field: 'min_fare_ghana', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_lesotho'), field: 'min_fare_lesotho', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_malawi'), field: 'min_fare_malawi', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_mozambique'), field: 'min_fare_mozambique', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_senegal'), field: 'min_fare_senegal', type: 'numeric',  initialEditValue: 0},
    { title: t('min_fare_sierra_leone'), field: 'min_fare_sierra_leone', type: 'numeric',  initialEditValue: 0},

    { title: t('convenience_fee'), field: 'convenience_fees', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_burundi'), field: 'convenience_fees_burundi', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_canada'), field: 'convenience_fees_canada', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_drc'), field: 'convenience_fees_drc', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_kenya'), field: 'convenience_fees_kenya', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_nigeria'), field: 'convenience_fees_nigeria', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_rsa'), field: 'convenience_fees_rsa', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_rwanda'), field: 'convenience_fees_rwanda', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_uganda'), field: 'convenience_fees_uganda', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_tanzania'), field: 'convenience_fees_tanzania', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_benin'), field: 'convenience_fees_benin', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_burkina_faso'), field: 'convenience_fees_burkina_faso', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_cameroon'), field: 'convenience_fees_cameroon', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_gabon'), field: 'convenience_fees_gabon', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_ghana'), field: 'convenience_fees_ghana', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_lesotho'), field: 'convenience_fees_lesotho', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_malawi'), field: 'convenience_fees_malawi', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_mozambique'), field: 'convenience_fees_mozambique', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_senegal'), field: 'convenience_fees_senegal', type: 'numeric',  initialEditValue: 0},
    { title: t('convenience_fee_sierra_leone'), field: 'convenience_fees_sierra_leone', type: 'numeric',  initialEditValue: 0},
    
    

    {
      title: t('convenience_fee_type'),
      field: 'convenience_fee_type',
      lookup: { flat: t('flat'), percentage: t('percentage')},
    },
    
    {
      title: t('fleet_admin_comission'), field: 'fleet_admin_fee', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_burundi'), field: 'fleet_admin_fee_burundi', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_canada'), field: 'fleet_admin_fee_canada', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_drc'), field: 'fleet_admin_fee_drc', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_kenya'), field: 'fleet_admin_fee_kenya', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_nigeria'), field: 'fleet_admin_fee_nigeria', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_rsa'), field: 'fleet_admin_fee_rsa', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_rwanda'), field: 'fleet_admin_fee_rwanda', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_uganda'), field: 'fleet_admin_fee_uganda', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_tanzania'), field: 'fleet_admin_fee_tanzania', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_benin'), field: 'fleet_admin_fee_benin', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_burkina_faso'), field: 'fleet_admin_fee_burkina_faso', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_cameroon'), field: 'fleet_admin_fee_cameroon', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_gabon'), field: 'fleet_admin_fee_gabon', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_ghana'), field: 'fleet_admin_fee_ghana', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_lesotho'), field: 'fleet_admin_fee_lesotho', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_malawi'), field: 'fleet_admin_fee_malawi', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_mozambique'), field: 'fleet_admin_fee_mozambique', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_senegal'), field: 'fleet_admin_fee_senegal', type: 'numeric', 
     initialEditValue: 0
    },
    {
      title: t('fleet_admin_comission_sierra_leone'), field: 'fleet_admin_fee_sierra_leone', type: 'numeric', 
     initialEditValue: 0
    },
    
    
    { title: t('extra_info'), field: 'extra_info' , },
    { title: t('position'), field: 'pos', type: 'numeric', defaultSort:'asc'}
];

export const acceptBid = (selectedBooking, selectedBidder) => {
    return null;
}

export const BidModal = (props) => {
    return null
}

export const  downloadCsv = (data, fileName) => {
    const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
    a.setAttribute("download", finalFileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
// Column sort comparators, restored from the pre-incident production bundle.
// Production inlined these on every column; the semantics here are identical
// (rows missing the field sort last, ties keep their order).
export const sortByString = (field) => (a, b) =>
  a[field] || b[field]
    ? a[field]
      ? b[field]
        ? a[field].localeCompare(b[field])
        : -1
      : 1
    : 0;

export const sortByDate = (field) => (a, b) =>
  a[field] || b[field]
    ? a[field]
      ? b[field]
        ? moment(a[field]).unix() - moment(b[field]).unix()
        : -1
      : 1
    : 0;

export const sortByApproved = (a, b) =>
  a.approved === b.approved
    ? 0
    : a.approved === undefined || a.approved === null
      ? 1
      : b.approved === undefined || b.approved === null || a.approved
        ? -1
        : 1;

// CSV export used by the admin tables, restored from the production bundle.
// Production inlined this per table, varying only in which fields hold dates.
// Absent dates export as empty rather than "Invalid Date", which is how
// production already handled processDate.
export const buildCsvExport = (columns, data, dateFields = ['createdAt']) => {
  let hArray = [];
  const headerRow = columns.map((col) => {
    if (typeof col.title === 'object') {
      return col.title.props.text;
    }
    hArray.push(col.field);
    return col.title;
  });
  const dataRows = data.map(({ tableData, ...row }) => {
    for (const field of dateFields) {
      row[field] = row[field]
        ? new Date(row[field]).toLocaleDateString() + ' ' + new Date(row[field]).toLocaleTimeString()
        : '';
    }
    let dArr = [];
    for (let i = 0; i < hArray.length; i++) {
      dArr.push(row[hArray[i]]);
    }
    return Object.values(dArr);
  });
  const delimiter = ',';
  const csvContent = [headerRow, ...dataRows].map((e) => e.join(delimiter)).join('\n');
  downloadCsv(csvContent, 'download.csv');
};
